import React from 'react';
import { Text, View, StyleSheet, Image } from 'react-native';
import { Button } from '../../components';
import Host from '../../assets/images/become-a-host.jpg';
import { useHistory } from 'react-router-dom';
import TiltedImageLayout from '../../components/layouts/TiltedImageLayout';

const styles = StyleSheet.create({
  title: {
    fontSize: 40,
    fontWeight: 'bold',
    textAlign: 'start',
    marginVertical: 20,
  },
  copy: {
    fontSize: 'large',
    lineHeight: 'large',
    maxWidth: 500,
    width: '100%',
  },
});

function HostTeaser() {
  const history = useHistory();
  return (
    <TiltedImageLayout image={Host} shadow tilt>
      <View
        style={{
          alignItems: 'flex-start',
          alignSelf: 'center',
          flex: 1,
          flexBasis: 'auto',
        }}
      >
        <Text style={styles.title}>Verdiene Geld mit deinem Hobby.</Text>
        <Text style={styles.copy}>
          Biete an, was immer dir Spass macht: Einen Mittagstisch, eine
          Wanderung, einen Malkurs oder etwas ganz anderes. Wir kümmern uns ums
          Geld: Die Teilnehmer bezahlen direkt über die Webseite oder die App
          und deine Einnahmen werden dir automatisch gutgeschrieben.
        </Text>
        <Button
          text="Mehr erfahren"
          action={() => history.push('/become-a-host')}
          size="large"
          style={{ marginVertical: 20 }}
        />
      </View>
    </TiltedImageLayout>
  );
}

export default HostTeaser;
